<template>
  <component
    :is="link ? 'a' : 'div'"
    class="simple-image-teaser"
    :href="link.url"
    :target="link.openInNewWindow ? '_blank' : ''"
  >
    <img
      class="simple-image-teaser__image"
      :src="image.src"
      :alt="image.alt"
      :title="image.title"
      :width="image.width === 0 ? '100' : image.width"
      :height="image.height === 0 ? '100' : image.height"
      loading="lazy"
    >
    <span
      class="simple-image-teaser__text"
    >
      {{ image.title }}
    </span>
  </component>
</template>

<script>
  export default {
    props: {
      link: Object,
      image: Object,
    }
  }
</script>
